import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offer = document.getElementById('oferta');
      if (!offer) {
        setVisible(false);
        return;
      }
      setVisible(offer.getBoundingClientRect().bottom <= window.innerHeight);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-179" data-mp="c6qs5pca3svg">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-line bg-night/95 px-4 py-3 backdrop-blur" data-id="element-180" data-mp="c5pdzbzyuq9i">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-181" data-mp="gvfc4m5o8p67">
            <div className="hidden sm:block" data-id="element-182" data-mp="c4yyb0xxv1jb">
              <p className="font-sans text-sm font-semibold text-parchment" data-id="element-183" data-mp="c471jmsluxrg">
                Botiquín Espiritual · 50 tarjetas + 4 bonos
              </p>
              <p className="font-sans text-xs text-parchment/55" data-id="element-184" data-mp="lv1zhof7rlsq">
                <span className="line-through" data-id="element-185" data-mp="luid9vij6b8w">{launchOffer.regularPrice}</span> hoy{' '}
                <span className="font-semibold text-gold-soft" data-id="element-186" data-mp="zu1es5gu6oc8">{launchOffer.price}</span>{' '}
                · garantía 7 días
              </p>
            </div>
            <CtaButton size="block" href={checkoutUrl} className="sm:w-auto sm:px-8" data-id="element-187" data-mp="31l4omsiwjyvq">
              {cta.short}
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}